import { MvnMessage } from "@utils/lang";
import { notify, request } from "@coralblack/flax";
import { user } from "./keys";
import { useBaseMutation } from "../index";
import { AUTH_USER_LANG } from "@maven-msg/lang";
import { CreateAuthTokenRequestForTest } from "@maven-rest/sso/AuthToken.dto";
import { AuthTokenFlax } from "@maven-rest/sso/AuthToken.flax";
import { CreateUserRequest } from "@maven-rest/sso/User.dto";
import { UserFlax } from "@maven-rest/sso/User.flax";

export const useCreateUserMutation = () => {
  return useBaseMutation({
    mutationKey: user.create(),
    mutationFn: async (req: CreateUserRequest) => {
      const resp = await request(UserFlax.createUser(req));

      return resp.data;
    },
    onSuccess: () => {
      notify(MvnMessage(AUTH_USER_LANG.USER_SIGNUP_SUCC), "SUCC");
    },
    onError: (error: any) => {
      notify(
        MvnMessage(AUTH_USER_LANG.USER_SIGNUP_FAIL, {
          message: error?.response?.data?.message || error,
        }),
        "ERROR"
      );
    },
  });
};

export const useLoginMutation = () => {
  return useBaseMutation({
    mutationKey: user.login(),
    mutationFn: async (req: CreateAuthTokenRequestForTest) => {
      const resp = await request(AuthTokenFlax.createAuthTokenForTest(req));

      return resp.data;
    },
    onSuccess: () => {},
    onError: (error: any) => {
      notify(
        MvnMessage(AUTH_USER_LANG.USER_SIGNIN_FAIL, {
          message: error?.response?.data?.message || error,
        }),
        "ERROR"
      );
    },
  });
};
